export const stripeKey = "pk_live_51QG05vC4AKqm93HpI6MDqVHKiZjxjlgqsIDqooQ6rIUhLHDkpsFAjq9MIOUypzVy1sXwfc854ukr7B6UFfqPHLXv00ZWFRrUo4";
export const api = "https://api.moneyguided.com";
//export const api = "https://api.moneyguided.com"
export const configUri = "dev";
export const whatsAppNumber = "447356222292";
export const wellKnownLogosOnly = true;
